export default {
  "b2b.zadosti-historie-grid.action-filter": "Filtrovat",
  "b2b.zadosti-historie-grid.filter.dateFrom.label": "Datum od",
  "b2b.zadosti-historie-grid.filter.dateTo.label": "Datum do",
  "b2b.zadosti-historie-grid.filter.requestStatus.label": "Stav žádosti",
  "b2b.zadosti-historie-grid.label": "Historie žádostí"
};
